import React, { useState, useRef, useEffect} from "react";
import Heroimg from "./Heroimg/heroimg";
import Plan from "./plan/plan";
import Tradingportfolio from "./tradingportfilo/tradingportfoli"; 
import PlanChange from "./planchang/PlanChange";
import PricingPlan from "../Products/PricingPlan/PricingPlan";
import ZeroAccount from "./Zeroaccount/zeroaccount";
import { useLocation } from 'react-router-dom';
import { useCookies } from "react-cookie";
import TrackApi from "../Activity_Track/TrackApi";
 
function Pricing(props) {
  const [cookies, setCookie] = useCookies(['LeadId']);

    window.scrollTo(0, 0)
    let pricing = window.location.pathname;
    const location = useLocation();
    pricing=pricing.replace('/','');
    const [plan, setPlan] = useState('');
    const observed = useRef(null);
    const ref = useRef(); 
    const Plan_details = (evt) => {
       // console.log("aaaa:" + evt);
        setPlan(evt);
    }
    useEffect(() => {      
        if (location.state != null && location.state.plan != '') {
            setPlan(location.state.plan);
            window.scrollTo({
                top: observed.current.offsetTop - 100,
                behavior: 'smooth',
            });
        }       
    }, []);
    const trackData=(id)=>{
        const payloadData={
          "RelatedProspectId":id,
          "ActivityNote": "pricing page visit",
          "mx_Custom_1": "Pricing",
          "mx_Custom_2": "Your pricing Note",
          "mx_CustomObject_81":window.location.href
         }
         TrackApi(payloadData);
      }
      useEffect(()=>{
      
    if(cookies && cookies.RelatedProspectId){
      trackData(cookies.RelatedProspectId);
    }
        
      })
  return (
      <>
       
      <Heroimg />
      {/* <Plan /> */}
          <PricingPlan Plan_details={Plan_details} product={pricing}  />
      <ZeroAccount />
          {/* <Tradingportfolio /> */}
          <div ref={observed} className="App">
              <PlanChange plan={plan} />
          </div>

    </>
  );
}
export default Pricing;
